import {
  CleanTournament,
  TournamentParticipant,
} from '../../domain/models/tournament.model';

export interface TournamentState {
  tournaments: CleanTournament[] | null;
  userTournaments: CleanTournament[] | null;
  userCreatedTournaments: CleanTournament[] | null;
  tournamentDetails: TournamentParticipant[] | null;
  lastUpdated: number | null;
  isTournamentLoading: boolean;
  isUserTournamentLoading: boolean;
  isUserCreatedTournamentLoading: boolean;
  isTournamentDetailsLoading: boolean;
  error: string | null;
}

export const initialTournamentState: TournamentState = {
  tournaments: null,
  userTournaments: null,
  userCreatedTournaments: null,
  tournamentDetails: null,
  lastUpdated: null,
  isTournamentLoading: false,
  isUserTournamentLoading: false,
  isUserCreatedTournamentLoading: false,
  isTournamentDetailsLoading: false,
  error: null,
};
